import { Map, List, Set, fromJS } from 'immutable';
import {nowString} from "lib/date";

// We'll need so many actions here we might as well import them all
import * as actions from "./actions";
import { STATE_HYDRATE } from "state/persist";

const initialState = new Map({
  lastSchoolID: undefined,

  isSchoolsLoading: true,
  schools: new Map(),
  migratedSchools: new Map(),

  isMessagesLoading: true,
  messages: new Map(),

  isNoticesLoading: true,
  notices: new Map(),

  isTermsLoading: true,
  terms: new Map(),

  readMessageIDs: new Set(),

  replyDrafts: new Map(),

  pendingReplies: new Map(),

  expandedNoticeID: null,

  isGuideOpen:false,
  
  goToMessageID: null,
  goToNoticeID: null
});


function failAllPendingReplies(hydratedPendingReplies) {
  return hydratedPendingReplies
    .toSeq()
    .map( (pendingReply) => {
      return pendingReply.set("status", "failed")
    })
    .toMap()
}

function mergeHydrateState(state, action) {
  const hydratedState = action.payload.state;
  return state
    .set("replyDrafts", hydratedState.getIn(["teachers", "replyDrafts"]) )
    .set("readMessageIDs", hydratedState.getIn(["teachers", "readMessageIDs"], List()).toSet())
    .set("guideShownDate", hydratedState.getIn(["teachers", "guideShownDate"]))
    .set("pendingReplies", failAllPendingReplies( hydratedState.getIn(["teachers", "pendingReplies"]) ) )
}
// Root reducer
export default function reducer(state = initialState, action) {

  switch (action.type) {
    case STATE_HYDRATE:
      return mergeHydrateState(state, action);

    case actions.SET_LAST_SCHOOL:
      return state.set("lastSchoolID", action.payload.schoolID);

    case actions.FETCH_SCHOOLS:
      return state.set("isSchoolsLoading", true);

    case actions.FETCH_MESSAGES:
      return state.set("isMessagesLoading", true);

    case actions.FETCH_NOTICES:
      return state.set("isNoticesLoading", true);

    case actions.FETCH_TERMS:
      return state.set("isTermsLoading", true);

    case actions.FETCH_SCHOOLS_COMPLETED:
      return state
        .set("isSchoolsLoading", false)
        .set('schools', action.payload.schools)
        .set("migratedSchools", action.payload.migratedSchools)
        .set("lastSchoolID", action.payload.schools.first().id);

    case actions.FETCH_MESSAGES_COMPLETED:
      const pendingReplies = state.get("pendingReplies")
        .filter((pendingReply) => pendingReply.get("status") !== "sent");
      return state
        .set("isMessagesLoading", false)
        .set('messages', action.payload.messages)
        .set("pendingReplies", pendingReplies);

    case actions.MERGE_MESSAGES:
      const migratedSchools = state.get("migratedSchools");
      const messages = state.get("messages");
      return state.set("messages", messages.map(m => {
        const school = migratedSchools.find(s => s.schoolID === m.schoolID);
        // If the school has been migrated then set the school ID of the message to the ID of the Neo school instead
        return (school !== undefined ? m.set("schoolID", school.neoId) : m);
      }));

    case actions.FETCH_NOTICES_COMPLETED:
      return state
        .set("isNoticesLoading", false)
        .set('notices', fromJS(action.payload.notices));

    case actions.FETCH_TERMS_COMPLETED:
      return state
        .set("isTermsLoading", false)
        .set('terms', fromJS(action.payload.terms));

    case actions.MARK_MESSAGES_READ:
      return state.mergeIn(["readMessageIDs"], action.payload.messageIDs);

    case actions.SET_REPLY_DRAFT:
      return state.setIn(["replyDrafts", action.payload.schoolID], action.payload.body);

    case actions.SEND_REPLY:
      return state.deleteIn(["replyDrafts", action.payload.schoolID]);

    case actions.ADD_PENDING_REPLY:
      return state.setIn(["pendingReplies", action.payload.pendingReplyID], Map(action.payload.pendingReply));

    case actions.RETRY_PENDING_REPLY:
      const { pendingReplyID } = action.payload;
      const { body, schoolID } = state.getIn(["pendingReplies", pendingReplyID]).toJS();
      return state
        .setIn(["replyDrafts", schoolID], body)
        .deleteIn(["pendingReplies", pendingReplyID]);

    case actions.SET_PENDING_REPLY_STATUS:
      return state.setIn(["pendingReplies", action.payload.pendingReplyID, "status"], action.payload.status);

    case actions.SET_EXPANDED_NOTICE:
      return state.set("expandedNoticeID", action.payload.noticeID);

    case actions.OPEN_GUIDE:
      return state.set("isGuideOpen", true)

    case actions.CLOSE_GUIDE:
      return state
        .set("isGuideOpen", false)
        .set("guideShownDate", nowString() );
    
    case actions.GO_TO_MESSAGE:
      return state.set("goToMessageID", action.payload.messageID);
      
    case actions.CLEAR_GO_TO_MESSAGE:
      return state.set("goToMessageID", null);
      
    case actions.GO_TO_NOTICE:
      return state.set("goToNoticeID", action.payload.noticeID);
      
    case actions.CLEAR_GO_TO_NOTICE:
      return state.set("goToNoticeID", null);
    
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/state/teachers/reducer.js